import { app } from '../../../bootstrap/core';
import { downloadComponent } from './download.component';

app.component('download', downloadComponent);
